module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.board.fetchingStatus === 'fetching') ? _c('loader-large') : [(Object.keys(_vm.orderedCategories || {}).length === 0) ? _c('div', {
    staticClass: "no-forums"
  }, [_vm._v("This Group doesn't have any forums set up")]) : _vm._l((_vm.orderedCategories), function(category) {
    return _c('category-item', {
      attrs: {
        "category": category,
        "is-moderator": _vm.isModerator,
        "board-id": _vm.boardId,
        "root": _vm.root
      }
    })
  }), _vm._v(" "), (_vm.isModerator && !_vm.showAddCategoryForm) ? _c('section', {
    staticClass: "add-category",
    on: {
      "click": function($event) {
        _vm.showAddCategoryForm = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v(" Add a Category\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isModerator && _vm.showAddCategoryForm && _vm.savingAddCategory) ? _c('saver-large') : _vm._e(), _vm._v(" "), (_vm.isModerator && _vm.showAddCategoryForm && !_vm.savingAddCategory) ? _c('section', {
    staticClass: "add-category-form"
  }, [_c('h2', [_vm._v("Add Category")]), _vm._v(" "), (_vm.addCategoryError) ? _c('div', {
    staticClass: "validation-messages error"
  }, [_vm._v(_vm._s(_vm.addCategoryError))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategoryTitle),
      expression: "newCategoryTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Category Title"
    },
    domProps: {
      "value": (_vm.newCategoryTitle)
    },
    on: {
      "focus": function($event) {
        _vm.addCategoryError = ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCategoryTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPrivate),
      expression: "isPrivate"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPrivate) ? _vm._i(_vm.isPrivate, null) > -1 : (_vm.isPrivate)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isPrivate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPrivate = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isPrivate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPrivate = $$c
        }
      }
    }
  }), _vm._v(" Members Only Category")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addCategory($event)
      }
    }
  }, [_vm._v("Add Category")])]) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21f6742f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Forums/ForumsCategoryList.vue
// module id = 835
// module chunks = 2